<template>
    <div v-if="userData.is_staff">
        <v-row>
            <v-col cols = "1">
            </v-col>
            <v-col cols = "1">
                <v-btn 
                    style="background-color:#B198C8"
                    icon
                    @click="change_page('prev')"
                    >
                    <v-icon big >mdi-arrow-left-thick</v-icon>
                </v-btn>
            </v-col>
            <v-col cols = "2">
            </v-col>
            <v-col cols = "2">
                <v-select v-model="span" 
                  :items="span_ops"
                  @change="changed_span">
                </v-select>
            </v-col>
            <v-col cols = "1">
            </v-col>
            <v-col cols = "2">
                <v-btn 
                    style="background-color:#B198C8"
                    icon
                    @click="get_items"
                    >
                    <v-icon big >mdi-refresh</v-icon>
                </v-btn>
            </v-col>
            <v-col cols = "1">
                <v-btn 
                    @click="change_page('next')"
                    style="background-color:#B198C8"
                    icon
                    >
                    <v-icon >mdi-arrow-right-thick</v-icon>
                </v-btn>
            </v-col>
            <v-col cols = "1">
            </v-col>
        </v-row>
        <v-data-table :headers="headers" :items="items" :loading="loading" style="line-height:3" :sortable="false" 
                        :items-per-page="30" hide-default-footer dense>
            <template v-slot:item=" {item} ">
                    <tr v-if = "item['row'] != 'last_update'">
                        <td >
                            {{item['row']}}        
                        </td>
                        <td v-for="h in headers.slice(1)" class="pa-0">
                            <div :style="{ 'background-color': get_color(item['row'],item[h.value]), 'min-height': '100 %','margin-left':'0.1vh' }">
                                {{item[h.value]}}
                            </div>
                        </td>
                    </tr>
                    <tr v-else>
                        <td >
                            {{item['row']}}        
                        </td>
                        <td v-for="h in headers.slice(1)" class="pa-0">
                            <v-row>
                                <div>
                                    {{item[h.value]}}
                                </div>
                            </v-row>
                            <v-row>
                                <v-btn @click="update(h.value)" style="background-color:#B198C8">
                                    Actualizar
                                </v-btn>
                            </v-row>
                        </td>

                    </tr>
                </template>
         </v-data-table>
    </div>
</template>

<script>
import { mapActions, mapGetters,mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { client2 } from "@/api/client";

export default {
    components: {
    },
    computed: {
        ...mapState([
            'session_information'
            ]),
        ...mapGetters({
            userData: 'me/userData',
        }),
    },
    data() {
        return {
            items:[],
            headers:[],
            loading:false,
            utils : {},
            page:0,
            span:'day',
            span_ops:['day','month'],
        }
    },
    methods: {
        get_items(){
            this.loading = true
            let url = 'get_kpi_doc_errors_table/'+this.page.toString() +'/'+this.span
            client2.get(url).then(response => {
                    console.log(response.data)
                    this.items = response.data['items'];
                    this.headers = response.data['headers'];
                    this.loading=false
                }).catch(err => {
                    console.debug(err);
                });
        },
        get_color(row,val){
            let opacity = 0
            if(row == 'sample_size'){
                let div = 40000
                if(this.span == 'month'){
                    div = 500000
                }
                opacity = val/div
                if (opacity > 1) {
                    opacity = 1
                }
                return  'rgba(77, 199, 223,'+ opacity.toString() +')'
            }
            else if(row.includes('error')){
                opacity = parseFloat(val)
                opacity = opacity/25
                if (opacity > 1) {
                    opacity = 1
                }
                return  'rgba(223, 77, 77,'+ opacity.toString() +')'
            }
            else if(row == 'valid_for_training' || row == 'processed_correctly'){
                opacity = parseFloat(val)
                opacity = opacity/80
                if (opacity > 1) {
                    opacity = 1
                }
                return  'rgba(134, 210, 103,'+ opacity.toString() +')'
            }
            else if(row == 'calc_ratio'){
                opacity = val.split('/')[0]/val.split('/')[1]
                return  'rgba(177, 152, 200,'+ opacity.toString() +')'

            }
            else{
                return  'rgba(247, 245, 248,1)'
            }
        },
        update(val){
            this.loading = true
            let url = 'calculate_kpi/'
            client2.patch(url,{day:val}).then(() => {
                    this.loading=false
                    this.get_items()
                    
                }).catch(err => {
                    console.debug(err);
                });
        },
        change_page(val){
            if(val == 'next'){
                this.page +=1
            }
            else if(val == 'prev'){
                this.page -=1
            }
            this.get_items()
        },
        changed_span(){
            this.page = 0
            this.get_items()
        }
        
    },
    mounted(){
        this.get_items()
    }
}
</script>
<style>


</style>           
